import { CustomConnectorDto } from '@/models/connectors';

/**
 * Returns true when a workspace connector whose name contains the given keyword
 * (case-insensitive) is authenticated/connected.
 */
export const isConnectorConnected = (connectors: CustomConnectorDto[] | undefined, keyword: string): boolean =>
  connectors?.some((connector) => connector.name.toLowerCase().includes(keyword.toLowerCase()) && connector.isAuthenticated) ?? false;
